'use client'

import { usePathname } from 'next/navigation'
import { Suspense } from 'react'
import { ModalRoot } from '@/components/modal'
import { getIsChromelessPath } from '@/features/app/chromeless-paths'
import { LayoutCode } from '@/features/code/layout-code'
import { Footer } from '@/features/footer/footer'
import { CookieBanner } from '@/features/gdpr/cookie-banner'
import { Navigation } from '@/features/navigation/navigation'
import { SentryConsentGate } from '@/features/sentry/sentry-consent-gate'
import { NeotasteStructuredData } from '@/features/seo/structured-data/neotaste-structured-data'
import { IChildrenProps } from '@/typings/children-props'

export const App = ({ children }: {} & IChildrenProps) => {
    const isChromeless = getIsChromelessPath(usePathname())

    return (
        <div className="app-root">
            <NeotasteStructuredData />

            <Suspense>
                <LayoutCode />
            </Suspense>

            {!isChromeless && <Navigation />}

            {children}

            <Suspense>
                <ModalRoot />
            </Suspense>

            <CookieBanner />
            <SentryConsentGate />

            {!isChromeless && <Footer />}
        </div>
    )
}
